export const mutations = {
  SET_DATA(state, payload) {
    state.history = payload;
  },
  IS_LOADING(state, payload) {
    state.isLoading = payload;
  }
};
